import { GET_ID_INSITUTE_CLEAR_VERFIDATION_URL, GET_ORGANISATION_LIST, IMPORT_ADMIN_EXCEL, DOWNLOAD_EXCEL } from "../../../config/adminUrlConfig";
import { ApiService, FileUploadService } from "../../../config/apiServices";

export const UploadAdminExcel = (data) => {
    return FileUploadService.post(IMPORT_ADMIN_EXCEL,data);
};


// export const getOrganisationList = (currentPage, perPage) => {
//     return ApiService.get(GET_ORGANISATION_LIST);
// };

export const getOrganisationList = (perPage,currentPage,selectedStatus,searchData,selectedDistrictId,selectedCategory,selectedSubCategoryId,selectedSportId = "") => {
    return ApiService.get(`${GET_ORGANISATION_LIST}?number=${perPage}&page=${currentPage}&status=${selectedStatus}&search=${searchData}&city=${selectedDistrictId}&category_type=${selectedCategory}&sub_category_type=${selectedSubCategoryId}&sport_id=${selectedSportId}`);
};

export const getOrganisationListForExcel = (userId, searchData,selectedDistrictId,selectedSubCategoryId,selectedSportId) => {
    return ApiService.get(`${DOWNLOAD_EXCEL}${userId}?search=${searchData}&city=${selectedDistrictId}&sub_category_type=${selectedSubCategoryId}&sport_id=${selectedSportId}`);
}

export const getDwnLoadOrganisationList = (selectedStatus,searchData,selectedDistrictId,selectedSubCategoryId,selectedSportId) => {
    return ApiService.get(`${GET_ORGANISATION_LIST}?&status=${selectedStatus}&search=${searchData}&city=${selectedDistrictId}&sub_category_type=${selectedSubCategoryId}&sport_id=${selectedSportId}`);
};



export const clearInsituteVerfication = (data) => {
    return ApiService.post(GET_ID_INSITUTE_CLEAR_VERFIDATION_URL,data);
};

